import { useSetPlayerStoreData } from '../hooks'
import { playerStoreKeys } from '../playerStoreConstants'

export const useSetPlayerLimit = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()

  const setPlayerLimit = data => {
    const limitMessages = {
      Wager: ['WagerLimitProcessor'],
      Loss: ['LossLimitsProcessor']
    }

    const limit = limitMessages[data.limitReached] || ''

    if (limit) {
      console.log('[Player action: triggerLimit] limit', limit, data.limitNotice)
    } else {
      console.log('[Player action: triggerLimit] limit does not reached')
    }

    setPlayerStoreData(
      {
        [playerStoreKeys.limitTriggered]: limit,
        [playerStoreKeys.limitNotice]: data.limitNotice
      },
      'setPlayerLimit'
    )
  }

  return { setPlayerLimit }
}
